import http from '@/plugins/http';

export default {
    // 私钥
    privateKey: null,

    //Authcode 有效时间
    authCodeEffectiveTime: null,

    // 获取Authcode有效时间
    async getAuthCodeTime() {
        if (this.authCodeEffectiveTime) {
            return Promise.resolve(this.authCodeEffectiveTime);
        } else {
            const res = await http.GET(`api/System/GetAuthCodeEffectiveTime`);
            if (res.Success) {
                this.authCodeEffectiveTime = res.Result;
                return this.authCodeEffectiveTime;
            } else {
                return Promise.reject('授权码有效时间获取失败');
            }
        }
    },

    // 获取私钥
    async getPrivateKey() {
        if (this.privateKey) {
            return Promise.resolve(this.privateKey);
        } else {
            const res = await http.GET(`api/System/GetPrivateKey`);
            if (res.Success) {
                this.privateKey = res.Result;
                return this.privateKey;
            } else {
                return Promise.reject('私钥获取失败');
            }
        }
    },

    //获取企业基本信息
    getEntBaseInfo() {
        return http.GET(`api/System/GetEntBaseInfo`);
    },
    //保存企业基本信息
    saveEntBase(param) {
        return http.POST(`api/System/SaveEntBaseInfo`, param);
    },
    //获取企业logo信息
    saveEntLogoInfo(param) {
        return http.POST(`api/System/SaveEntLogoInfo`, param);
    },
    getLogoInfo() {
        return http.GET(`api/System/GetEntLogoInfo`);
    },
};
